import React, { Component } from 'react'

import './inline.scss'

class Inline extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
    }
  }

  getSpacingClass () {
    let spacing = typeof this.props.spacing === 'string' ? parseInt(this.props.spacing) : this.props.spacing
    if (spacing < 1) return ''
    return ' pg-mb-' + spacing
  }

  getAlignChildrenClass () {
    switch (this.props.alignChildren) {
      case undefined:
      case null:
      case 'top':
        return ' align-start'
      case 'center':
        return ' align-center'
      case 'bottom':
        return ' align-end'
    }
  }

  getStyle () {
    let style = 'element-inline' + this.getSpacingClass() + this.getAlignChildrenClass()  // + this.getSizeClass()

    if (this.props.block) style += ' element-inline--block'

    if (this.props.fullWidth) style += ' full-width'
    return style
  }

  render () {
    let children = this.props.children
    if (children !== undefined && children !== null && !Array.isArray(children)) {
      children = [children]
    }
    return (
      <div className={this.getStyle()}>
        {children !== undefined && children !== null && children.map((child, key) => {
          let style = 'inline-item'
          if (this.props.fillChildNum.includes(key)) {
            style += ' inline-item--fill'
          }
          if (child === false) return null
          return (
            <div className={style} key={key}>
              {child}
            </div>
          )
        })}
      </div>
    )
  }

}

Inline.defaultProps = {
  // size: 's',
  spacing: 1, // Spacing can currently range from 0 to 8
  block: false,
  fillChildNum: [],
  alignChildren: 'center', // top, center, bottom
  fullWidth: false
}

export default Inline



// WEBPACK FOOTER //
// ./src/app/shared/elements/inline/index.js